import {
    COMPETITION_PARTICIPANTS_REQUEST,
    COMPETITION_PARTICIPANTS_FAILURE,
    COMPETITION_PARTICIPANTS_SUCCESS,
} from 'actions';

const initialState = {
    data: [],
    // competitionId → CompetitionParticipant[] (the roster of ONE competition)
    dataByCompetition: {},
    isFetched: [],
    isFetching: [],
};

export const competitionParticipantsListReducer = (state = initialState, action) => {
    const { type, data, competitionId } = action;
    switch (type) {
        case COMPETITION_PARTICIPANTS_SUCCESS:
            return {
                ...state,
                isFetched: [...state.isFetched, competitionId],
                isFetching: state.isFetching.filter(id => id !== competitionId),
                data: [...state.data, ...data],
                dataByCompetition: {
                    ...state.dataByCompetition,
                    [competitionId]: data,
                },
            };

        case COMPETITION_PARTICIPANTS_REQUEST:
            return {
                ...state,
                isFetching: [...state.isFetching, competitionId],
            };

        case COMPETITION_PARTICIPANTS_FAILURE:
            return {
                ...state,
                isFetching: state.isFetching.filter(id => id !== competitionId),
            };

        default:
            return state;
    }
};
